import React from "react";
import lazyPage from "../../../../common/helpers/lazyPage";
import Loader from "../../../components/Loader";

export default lazyPage(
    "src/front/pages/play-plan/ConnectModal/ConnectModal.tsx",
    () => import("./ConnectModal"),
    <Loader margin="auto" />,
);
